import React from 'react';
import { Section } from './Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section data-id="element-95">
      <div className="max-w-3xl mx-auto bg-white border-2 border-rose-light/30 rounded-3xl p-8 md:p-12 text-center shadow-sm relative overflow-hidden" data-id="element-96">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-rose-light via-rose to-rose-light" data-id="element-97"></div>

        <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-98">
          <ShieldCheck className="w-8 h-8 text-rose" data-id="element-99" />
        </div>

        <h2 className="text-2xl md:text-3xl font-serif mb-6" data-id="element-100">
          Garantía de Transformación
        </h2>

        <div className="space-y-4 text-lg text-brown-light" data-id="element-101">
          <p data-id="element-102">
            Creo completamente en el poder de RENACIDA para transformar tu
            posparto.
          </p>
          <p data-id="element-103">
            Por eso te ofrezco una garantía total: si aplicas el proceso y
            sientes que no fue lo que necesitabas, te devuelvo tu inversión
            completamente.
          </p>
          <p className="font-medium text-brown-dark" data-id="element-104">
            Sin preguntas. Sin complicaciones. Sin dramas.
          </p>
          <p className="text-xl font-serif italic text-rose-dark pt-4" data-id="element-105">
            El único riesgo es quedarte igual.
          </p>
        </div>
      </div>
    </Section>;
}